export const EXPERT_BACKGROUND_OPTIONS = [
  {
    value: "formally_trained",
    label: "Uddannet inden for faget",
    description: "Jeg har en relevant uddannelse eller faglig titel.",
  },
  {
    value: "industry_experienced",
    label: "Praktisk erhvervserfaring",
    description: "Jeg har arbejdet professionelt med området uden en bestemt faguddannelse.",
  },
  {
    value: "student",
    label: "Studerende",
    description: "Jeg er i gang med en relevant uddannelse.",
  },
  {
    value: "self_taught",
    label: "Selvlært",
    description: "Jeg har opbygget min viden gennem egne projekter og praktisk erfaring.",
  },
  {
    value: "hobbyist",
    label: "Erfaren hobbyudøver",
    description: "Jeg beskæftiger mig seriøst med området i min fritid.",
  },
];

export function expertBackgroundLabel(value) {
  return EXPERT_BACKGROUND_OPTIONS.find((option) => option.value === value)?.label || "Baggrund ikke angivet";
}
